import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const settingsApi = {
  getPreferences: () => api.get(API_ROUTES.settings.preferences),
  updatePreferences: (data) => api.put(API_ROUTES.settings.preferences, data),
  getNotifications: () => api.get(API_ROUTES.settings.notifications),
  updateNotifications: (data) => api.put(API_ROUTES.settings.notifications, data),
  getSocietyOperations: (params) => api.get(API_ROUTES.settings.societyOperations, { params }),
  updateSocietyOperations: (data, params) => api.put(API_ROUTES.settings.societyOperations, data, { params }),
  getGuardPolicy: (params) => api.get(API_ROUTES.settings.societyGuardPolicy, { params }),
  updateGuardPolicy: (data, params) => api.put(API_ROUTES.settings.societyGuardPolicy, data, { params }),
  getSupportTicketDigest: () => api.get(API_ROUTES.settings.supportTicketDigest),
  updateSupportTicketDigest: (data) => api.put(API_ROUTES.settings.supportTicketDigest, data),
  getPlatformPolicies: () => api.get(API_ROUTES.settings.platformPolicies),
  updatePlatformPolicies: (data) => api.put(API_ROUTES.settings.platformPolicies, data),
};
